module.exports = __webpack_public_path__ + "img/un.un4388dfb.svg";